
import {defineComponent, reactive, toRefs, ComputedRef, computed} from 'vue';
import { Icon } from 'scvant';
import {useRoute} from "vue-router";
import {GetDetectPreview} from '@/service';
// import reportItem from './reportItem.vue'
// import reportPicItem from './reportPicItem.vue'
import config from './cont/config.vue'
import paint from './cont/paint.vue'
import ecu from './cont/ecu.vue'
import detect from './cont/detect.vue'
import anotherDetect from './cont/anotherDetect.vue'
import remark from './cont/remark.vue'
import procedures from './cont/procedures.vue'
import carPhotoList from './cont/carPhotoList.vue'
import markPhoto from './cont/markPhoto.vue'
import detectVideo from './cont/detectVideo.vue'
import batteryInfo from './cont/batteryInfo.vue'

interface State {
    // carInfo: object;
    // reportData: object;
    // renderList: object[];
    configureInfos: object[];
    paintCheck: object;
    ecuInfo: number;
    checkInfo: object;
    defectPhotoList: object[];
    procedurePhotoList: object[];
    markPhotoList: object[];
    videoList: object[];
    battery: object;
}

export default defineComponent({
    name: 'reportContent',
    components: {
        [Icon.name]: Icon,
        // reportItem,
        // reportPicItem,
        config,
        paint,
        ecu,
        detect,
        anotherDetect,
        remark,
        procedures,
        carPhotoList,
        markPhoto,
        detectVideo,
        batteryInfo
    },
    props: {
        reportData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    setup(props: any) {
        function setData (filedName) {
            return computed(() => {
                return props.reportData[filedName]
            })
        }
        let state: State = reactive({
            configureInfos: setData("configureInfos"),
            paintCheck: setData("paintCheck"),
            ecuInfo: setData("ecuInfo"),
            checkInfo: setData("checkInfo"),
            defectPhotoList: setData("defectPhotoList"),
            procedurePhotoList: setData("procedurePhotoList"),
            markPhotoList: setData("markPhotoList"),
            videoList: setData("videoList"),
            battery: {
                batteryDetect: setData("batteryDetect"),
                batterySOH: setData("batterySOH"),
            },
        });
        // let {reportData} = toRefs(props);
        // state.configureInfos = reportData.configureInfos;
        // state.paintCheck = reportData.paintCheck;
        // state.ecuInfo = reportData.ecuInfo;
        // state.checkInfo = reportData.checkInfo;
        // state.defectPhotoList = reportData.defectPhotoList;
        // state.procedurePhotoList = reportData.procedurePhotoList;
        // state.markPhotoList = reportData.markPhotoList;
        // state.videoList = reportData.videoList;
        return {
            state
        }
    },

})
